import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppNavBar from '../../helper/appbar';
import './page404.css';

const Page404 = () => {
  const navigate = useNavigate();
  return (
    <main >
      <AppNavBar navType={"_light"} />
      <section className='page404-main'>
        <h1>Oops, 404</h1>
        <p>You flew all the way here just to find nothing. We can help with that.</p>
        <ul>
          <li onClick={() => navigate("/")}>Go home</li>
          <li onClick={() => navigate("/demo")}>Request Demo</li>
          <li>
            <a href={`mailto:business@gokardinal.com"}}`}>
              Talk to sales
            </a>
          </li>
        </ul>
      </section>
    </main>
  );
};

export default Page404;